const mode_stages = {
    retail: [
        {
            title: 'Your Details',
            slug: '/your-details',
            skip_if_logged_in: true,
        },
        {
            title: 'Delivery Options',
            slug: '/delivery-options',
            show: (store) => Object.keys(store.getters['basket/ib_items']).length === 0 && Object.keys(store.getters['basket/dp_items']).length > 0
        },
        {
            title: 'Delivery Options - Duty Paid',
            slug: '/delivery-options/duty-paid',
            show: (store) => Object.keys(store.getters['basket/dp_items']).length > 0 && Object.keys(store.getters['basket/ib_items']).length > 0
        },
        {
            title: 'Delivery Options - In Bond',
            slug: '/delivery-options/in-bond',
            show: (store) => Object.keys(store.getters['basket/ib_items']).length > 0
        },
        {
            title: 'Delivery Options - In Bond Pre-Order',
            slug: '/delivery-options/in-bond-preorder',
            show: (store) => Object.keys(store.getters['basket/ibp_items']).length > 0
        },
        {
            title: 'Delivery Options - Duty Paid Pre-Order',
            slug: '/delivery-options/duty-paid-preorder',
            show: (store) => Object.keys(store.getters['basket/dpp_items']).length > 0
        },
        {
            title: 'Order Summary',
            slug: '/order-summary',
        }
        
    ]
}

function ResolveCheckoutStage(slug, mode, store) {
    var stages = CheckoutStages(mode, store);
    for (var i in stages) {
        if (stages[i].slug.replace(/^\/|\/$/g, '') === slug.replace(/^\/|\/$/g, '')) {
            return { num: parseInt(i), slug: stages[i].slug };
        }
    }

    return false;
}

function CheckoutStages(mode, store) {

    var ret = [];
    var stages = mode_stages[mode] ?? mode_stages['retail'];
    
    for (var i in stages) {

        if (Object.keys(store.state.basket.items).length < 1) {
            continue;
        }
        
        if (stages[i].skip_if_logged_in && !store.state.user.is_guest) {
            continue;
        }

        if (stages[i].show) {
            if (!stages[i].show(store)) {
                continue;
            }
        }
    
        ret.push(stages[i]);

    }

    return ret;

}

export { CheckoutStages, ResolveCheckoutStage };